const _school = [
  'schoolType',
  'schoolSdate',
  'schoolEdate',
  'schoolStype',
  'schoolEtype',
  'schoolName',
  'schoolScore',
  'schoolMajor',
  'schoolReason',
];

export const resumeType = Object.freeze({
  typeBase: {
    A: ['baseBirthday', 'baseGender', 'baseNameEn'],
    B: ['baseBirthday', 'baseGender', 'baseNameEn', 'baseAddr'],
    C: ['baseBirthday', 'baseGender', 'baseNameEn', 'baseNameCh'],
    D: ['baseBirthday', 'baseGender', 'baseNameEn', 'baseNameCh', 'baseAddr'],
    E: ['baseBirthday', 'baseGender', 'baseAddr'],
    F: ['baseBirthday', 'baseGender'],
    // 국적추가

    G: ['baseBirthday', 'baseGender', 'baseNameEn', 'baseNationality'],
    H: [
      'baseBirthday',
      'baseGender',
      'baseNameEn',
      'baseAddr',
      'baseNationality',
    ],
    I: [
      'baseBirthday',
      'baseGender',
      'baseNameEn',
      'baseNameCh',
      'baseNationality',
    ],
    J: [
      'baseBirthday',
      'baseGender',
      'baseNameEn',
      'baseNameCh',
      'baseAddr',
      'baseNationality',
    ],
    K: ['baseBirthday', 'baseGender', 'baseAddr', 'baseNationality'],
    L: ['baseBirthday', 'baseGender', 'baseNationality'],
  },

  typeEtc: {
    A: ['etcPhoneSub'],
    B: ['etcPhoneSub', 'etcPath'],
    C: [
      'etcPhoneSub',
      'etcRecommender',
      'etcRecommenderTel',
      'etcRecommenderRelation',
      'etcRecommenderOrg',
    ],
    D: [
      'etcPhoneSub',
      'etcPath',
      'etcRecommender',
      'etcRecommenderTel',
      'etcRecommenderRelation',
      'etcRecommenderOrg',
      'etcSalary',
    ],
    E: [
      'etcPhoneSub',
      'etcPath',
      'etcRecommender',
      'etcRecommenderTel',
      'etcRecommenderRelation',
      'etcRecommenderOrg',
      'etcSalary',
      'etcPosition',
      'etcCurrentSalary',
    ],
  },
  typeAddition: {
    A: ['veteransYn', 'impairmentYn'],
    B: ['veteransYn', 'veteransType', 'impairmentYn', 'impairmentType'],
    C: [
      'veteransYn',
      'veteransType',
      'veteransNumber',
      'impairmentYn',
      'impairmentType',
      'impairmentClass',
    ],
    D: ['veteransYn', 'impairmentYn', 'vulnerableYn'],
    E: [
      'veteransYn',
      'veteransType',
      'impairmentYn',
      'impairmentType',
      'vulnerableYn',
      'vulnerableType',
    ],
    F: [
      'veteransYn',
      'veteransType',
      'veteransNumber',
      'impairmentYn',
      'impairmentType',
      'impairmentClass',
      'vulnerableYn',
      'vulnerableType',
    ],
    G: [
      'veteransYn',
      'veteransType',
      'veteransRelation',
      'veteransGrade',
      'impairmentYn',
      'impairmentType',
      'impairmentClass',
    ],
    H: [
      'veteransYn',
      'veteransType',
      'veteransRelation',
      'veteransGrade',
      'impairmentYn',
      'impairmentType',
      'impairmentClass',
      'vulnerableYn',
      'vulnerableType',
    ],
  },
  typeMilitary: {
    A: [
      'militaryYn',
      'militaryKind',
      'militarySdate',
      'militaryEdate',
      'militaryType',
      'militaryClass',
      'militaryLevel',
      'militaryNumber',
      'militaryReason',
    ],
    B: [
      'militaryYn',
      'militaryKind',
      'militarySdate',
      'militaryEdate',
      'militaryType',
      'militaryClass',
      'militaryLevel',
      'militaryReason',
    ],
    C: [
      'militaryYn',
      'militarySdate',
      'militaryEdate',
      'militaryType',
      'militaryClass',
      'militaryLevel',
      'militaryReason',
    ],
    D: [
      'militaryYn',
      'militaryKind',
      'militarySdate',
      'militaryEdate',
      'militaryReason',
    ],
    E: ['militaryYn', 'militarySdate', 'militaryEdate', 'militaryReason'],
  },
  typeSchool: {
    A: [..._school],
    B: [..._school, 'schoolMajorSub'],
    C: [..._school, 'schoolFile'],
    D: [..._school, 'schoolFile', 'schoolMajorSub'],
    E: [..._school, 'schoolEtc'],
    F: [..._school, 'schoolMajorEtc'],
    G: [..._school, 'schoolMajorSub', 'schoolEtc'],
    H: [..._school, 'schoolMajorSub', 'schoolMajorEtc'],
    I: [..._school, 'schoolFile', 'schoolMajorEtc'],
    J: [..._school, 'schoolFile', 'schoolEtc'],
    K: [..._school, 'schoolMajorEtc', 'schoolEtc'],
    L: [..._school, 'schoolEtc', 'schoolFile', 'schoolMajorEtc'],
    M: [..._school, 'schoolMajorSub', 'schoolMajorEtc', 'schoolEtc'],
    // 주의: typeSchool에서 'N' 키는 사용 금지
    // 'N'은 학력 섹션 미사용 판단 기준값으로 예약되어 있음
    O: [..._school, 'schoolMajorSub', 'schoolFile', 'schoolMajorEtc'],
    P: [
      ..._school,
      'schoolFile',
      'schoolMajorSub',
      'schoolMajorEtc',
      'schoolEtc',
    ],
    Q: [..._school, 'schoolMajorSub', 'schoolFile', 'schoolEtc'],
  },
  typeLanguage: {
    A: ['languageName', 'languageScore', 'languageDate'],
    B: ['languageName', 'languageScore', 'languageOrg', 'languageDate'],
  },
  typeLicense: {
    A: ['licenseName', 'licenseOrg', 'licenseDate'],
    B: ['licenseName', 'licenseOrg', 'licenseDate', 'licenseNumber'],
  },
  typeCareer: {
    A: [
      'careerCompany',
      'careerSdate',
      'careerEdate',
      'careerReason',
      'careerDesc',
    ],
    B: [
      'careerCompany',
      'careerSdate',
      'careerEdate',
      'careerReason',
      'careerDesc',
      'careerOrg',
      'careerPosition',
      'careerEmpType',
    ],
    C: [
      'careerCompany',
      'careerSdate',
      'careerEdate',
      'careerReason',
      'careerDesc',
      'careerFile',
    ],
    D: [
      'careerCompany',
      'careerSdate',
      'careerEdate',
      'careerReason',
      'careerDesc',
      'careerOrg',
      'careerPosition',
      'careerEmpType',
      'careerFile',
    ],
    E: [
      'careerCompany',
      'careerSdate',
      'careerEdate',
      'careerReason',
      'careerDesc',
      'careerOrg',
      'careerPosition',
      'careerEmpType',
      'careerSalary',
    ],
    F: [
      'careerCompany',
      'careerSdate',
      'careerEdate',
      'careerReason',
      'careerDesc',
      'careerOrg',
      'careerPosition',
      'careerEmpType',
      'careerSalary',
      'careerRevenue',
      'careerNumEmps',
    ],
    G: [
      'careerCompany',
      'careerSdate',
      'careerEdate',
      'careerReason',
      'careerDesc',
      'careerOrg',
      'careerPosition',
      'careerEmpType',
      'careerSalary',
      'careerFile',
    ],
    H: [
      'careerCompany',
      'careerSdate',
      'careerEdate',
      'careerReason',
      'careerDesc',
      'careerOrg',
      'careerPosition',
      'careerEmpType',
      'careerSalary',
      'careerRevenue',
      'careerNumEmps',
      'careerFile',
    ],
    I: [
      'careerCompany',
      'careerSdate',
      'careerEdate',
      'careerReason',
      'careerDesc',
      'careerOrg',
      'careerPosition',
      'careerEmpType',
      'careerSalary',
      'careerRevenue',
      'careerNumEmps',
      'careerGroup',
      'careerTask',
    ],
    J: [
      'careerCompany',
      'careerSdate',
      'careerEdate',
      'careerReason',
      'careerDesc',
      'careerOrg',
      'careerPosition',
      'careerEmpType',
      'careerSalary',
      'careerRevenue',
      'careerNumEmps',
      'careerGroup',
      'careerTask',
      'careerFile',
    ],
  },

  typeSchoolActivity: {
    A: [
      'schoolactType',
      'schoolactOrganization',
      'schoolactSdate',
      'schoolactEdate',
      'schoolactDescription',
    ],
    B: [
      'schoolactType',
      'schoolactOrganization',
      'schoolactSdate',
      'schoolactEdate',
      'schoolactPosition',
      'schoolactDescription',
    ],
    C: [
      'schoolactType',
      'schoolactOrganization',
      'schoolactSdate',
      'schoolactEdate',
      'schoolactPosition',
      'schoolactDescription',
      'schoolactNote',
    ],
  },
  typeVolunteer: {
    A: [
      'volunteerType',
      'volunteerOrganization',
      'volunteerHours',
      'volunteerRegion',
    ],
  },
  typeEducation: {
    A: [
      'educationName',
      'educationSdate',
      'educationEdate',
      'educationOrg',
      'educationDesc',
    ],
    B: ['educationName', 'educationSdate', 'educationEdate', 'educationDesc'],
  },
  typeAwards: {
    A: ['awardsName', 'awardsOrg', 'awardsDate', 'awardsDesc'],
    B: ['awardsName', 'awardsDate', 'awardsDesc'],
  },
  typeSelfIntro: [],
  typeAbilityIntro: [],
  //typeFile: [],
  typeCustom: {
    A: ['custom1'],
    B: ['custom1', 'custom2'],
    C: ['custom1', 'custom2', 'custom3'],
    D: ['custom1', 'custom2', 'custom3', 'custom4'],
    E: ['custom1', 'custom2', 'custom3', 'custom4', 'custom5'],
    F: ['custom1', 'custom2', 'custom3', 'custom4', 'custom5', 'custom6'],
    G: [
      'custom1',
      'custom2',
      'custom3',
      'custom4',
      'custom5',
      'custom6',
      'custom7',
    ],
    H: [
      'custom1',
      'custom2',
      'custom3',
      'custom4',
      'custom5',
      'custom6',
      'custom7',
      'custom8',
    ],
    I: [
      'custom1',
      'custom2',
      'custom3',
      'custom4',
      'custom5',
      'custom6',
      'custom7',
      'custom8',
      'custom9',
    ],
  },
  typeCareerOverseas: {
    A: [
      'careerOverseasCountry',
      'careerOverseasSdate',
      'careerOverseasEdate',
      'careerOverseasDesc',
    ],
    B: [
      'careerOverseasCountry',
      'careerOverseasSdate',
      'careerOverseasEdate',
      'careerOverseasDesc',
      'careerOverseasFile',
    ],
  },
  typeProject: {
    A: [
      'projectName',
      'projectBuyer',
      'projectCompany',
      'projectSdate',
      'projectEdate',
      'projectContribution',
      'projectDesc',
    ],
  },
  typeComUses: {
    A: ['usesGubun', 'usesName', 'usesLevel', 'usesTerm'],
  },
});
